module.exports = __webpack_public_path__ + "img/1.f2ea0194.jpg";